import ContactForm from "../../components/contactForm/ContactForm";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import MapComponent from "../../components/mapComponent/MapComponent";
import TickSection from "../../components/tickSection/TickSection";
import './contactPage.css';
import { Helmet } from 'react-helmet-async';

const ContactPage = () => {
    return (
        <div>
            <Helmet>
                <title>Kontakt & Hitta till oss - Alpine Sport i Värmland</title>
                <meta
                    name="description"
                    content="Kontakta och hitta till Alpine Sport i Värmland för professionell skidservice, reparationer och rådgivning."
                />
                <meta property="og:title" content="Kontakt - Alpine Sport i Värmland" />
                <meta
                    property="og:description"
                    content="Kontakta och hitta till Alpine Sport i Värmland för professionell skidservice, reparationer och rådgivning."
                />
                <meta property="og:image" content="%PUBLIC_URL%/socials-image.png" />
                <link rel="icon" href="%PUBLIC_URL%/colours-favicon.png" type="image/png" />
                <meta property="og:url" content="https://alpinesport.se/kontakt" />
                <meta property="og:type" content="website" />
                <link rel="canonical" href="https://alpinesport.se/kontakt" />
            </Helmet>
            <Header />
            <main>
                <TickSection />
                <section className="contactPage-container">
                    <section className="contactPage-topSection">
                        <article className="contactPage-h2Container">
                            <h2>
                                Kontaktinformation
                            </h2>
                        </article>
                        <section className="contactPage-contactDetails-container">
                            <article>
                                <h4 className="contactPage-h4">
                                    Skicka meddelande
                                </h4>
                                <ContactForm />
                            </article>
                            <article>
                                <h4 className="contactPage-h4">
                                    Adress & Kontaktinformation
                                </h4>
                                <p>
                                    Dalgatan 14 <br />
                                    681 32 Kristinehamn
                                </p>
                                <p>
                                    Tel: 0768000202 <br />
                                    E-post: <a href="mailto:info@alpinesport.se" className="email-link">info@alpinesport.se</a>
                                </p>

                            </article>
                        </section>
                    </section>

                    <section className="contactPage-bottomSection">
                        <MapComponent latitude={59.314498} longitude={14.114883} />
                    </section>
                </section>

            </main>
            <Footer />
        </div>
    );
}

export default ContactPage;